/* src/app/components/login/login.component.scss */
.panel-heading {
  background-color: transparent !important;
  border-color: transparent !important;
  text-align: center !important;
  font-size: x-large !important;
  font-weight: bold !important;
  text-decoration: underline !important;
}
.panel {
  background-color: rgb(253, 193, 0);
}
.submit-button {
  background-color: rgb(65, 65, 65);
  color: white;
  border-color: none;
  border-radius: 0px;
}
.login-container {
  width: 400px;
}
.boxshadow {
  position: relative;
  -moz-box-shadow: 14px 14px 6px rgba(253, 193, 0, 0.6);
  -webkit-box-shadow: 14px 14px 6px rgba(253, 193, 0, 0.6);
  box-shadow: 14px 14px 6px rgba(253, 193, 0, 0.6);
  padding: 10px;
}
.left {
  text-align: left;
}
.container-center {
  display: inline-flex;
  height: 100%;
  justify-content: center;
  align-items: center;
}
.center-block {
  display: block;
  margin-right: auto;
  margin-left: auto;
}
input.ng-dirty.ng-invalid {
  border-color: #dc3545;
  z-index: 99;
}
::ng-deep .mat-mdc-progress-spinner circle {
  stroke: white;
}
.logo {
  vertical-align: middle;
}
.logo-text {
  margin-left: 10px;
  font-weight: bold;
  font-size: 30px;
  vertical-align: middle;
}
@media (max-height: 400px) {
  .logo-container {
    display: none;
  }
}
::ng-deep app-login .mat-mdc-text-field-wrapper {
  padding-left: unset !important;
  padding-right: 10px !important;
  width: 100% !important;
}
::ng-deep app-login [name=loginForm] {
  margin-top: 8px;
}
::ng-deep app-login .form-group * {
  vertical-align: middle;
  align-self: center;
}
::ng-deep app-login .mat-mdc-text-field-wrapper {
  background-color: unset !important;
  margin-left: 26px;
  padding-left: unset !important;
  border-bottom: 1.5px solid white;
}
::ng-deep app-login .mat-mdc-text-field-wrapper .mdc-line-ripple,
::ng-deep app-login .mat-mdc-text-field-wrapper .mat-mdc-button-persistent-ripple,
::ng-deep app-login .mat-mdc-text-field-wrapper .mdc-button__ripple,
::ng-deep app-login .mat-mdc-text-field-wrapper .mat-ripple,
::ng-deep app-login .mat-mdc-text-field-wrapper .mat-mdc-button-ripple {
  display: none !important;
}
::ng-deep app-login .submit-button {
  margin-left: 11px;
  margin-bottom: 10px;
}
::ng-deep app-login mat-label {
  color: black !important;
}
::ng-deep app-login .mat-mdc-form-field-required-marker {
  color: black !important;
  font-weight: 500;
  font-size: 19px !important;
}
/*# sourceMappingURL=login.component-LLHXGXGO.css.map */
